/**
 * 이력 조회 배선 Feature Flag. (LOGISPRD-12610)
 *
 * 이 화면은 1.0 부터 조회 API 없이 스캔 결과만 쌓아 왔다. 진입·필터 변경마다 호출이 하나 늘어나는
 * 변화라 munoconf 플래그로 가린다. 키는 화면코드가 아니라 도메인으로 짓는 munoconf 컨벤션을 따랐다
 * (`feature.returnMonitoring.dateTypeFilter` 선례).
 */
export const RECEIPT_SCAN_HISTORY_FLAG = 'feature.returnReceiptReceive.historyQuery'

/**
 * 등록센터 옵션 — 생성본 `handoff/page.generated.tsx` 의 RGR08CENTER_OPTIONS_DEMO 와 같은 5종이다.
 *  배선이 이 상수를 `options.RGR08CENTER_OPTIONS` 슬롯으로 넘겨 데모 목데이터를 대체한다. 1.0 도 하드코딩 5종이었다.
 * // TODO(spec): 운영 센터 목록 확인 필요 — 서버 조회 전환은 이번 범위가 아니다(공통 결정서 D8 후단).
 */
export const CENTER_OPTIONS = [
  { label: '신여주1', value: '신여주1' },
  { label: '신여주2', value: '신여주2' },
  { label: '신여주3', value: '신여주3' },
  { label: '신여주4', value: '신여주4' },
  { label: '파주1', value: '파주1' },
] as const

/** 등록센터·지정일 기본값 — 1.0 결함(화면 초기 선택과 실제 전송값이 어긋남)을 2.0 에서 바로잡는다. */
export const DEFAULT_CENTER_NM = '신여주1'

/** 오디오 자산 경로 — `Utils.assetUrl` 로 읽는다(레포에 `import 'x.mp3'` 선례가 없다). */
export const SOUND_PATHS = {
  success: '/sounds/success-sound.mp3',
  error: '/sounds/error-sound.mp3',
} as const

/** 진동 지속시간(ms) — 1.0 `navigator.vibrate(400)` 그대로. */
export const VIBRATE_DURATION_MS = 400

export const MESSAGES = {
  /** 1.0 `rtnChk=false`(입력 공란·서버 예외) 경로 — 서버 message 를 그대로 띄운다. */
  scanFailedFallback: '수령 처리 중 오류가 발생했습니다.',
} as const
